// HOC Bear Hunt Planner — translations
// Supported: en (English), ko (Korean), id (Indonesian), pt-BR (Brazilian Portuguese)

export const LANGUAGES = [
  { code: 'en',    label: 'English',    flag: 'EN' },
  { code: 'ko',    label: '한국어',       flag: 'KO' },
  { code: 'id',    label: 'Bahasa',     flag: 'ID' },
  { code: 'pt-BR', label: 'Português',  flag: 'PT' },
  { code: 'th',    label: 'ไทย',         flag: 'TH' },
  { code: 'fil',   label: 'Filipino',   flag: 'FIL' },
  { code: 'zh',    label: '简体中文',      flag: 'ZH' },
  { code: 'es',    label: 'Español',    flag: 'ES' },
  { code: 'ro',    label: 'Română',     flag: 'RO' },
  { code: 'it',    label: 'Italiano',   flag: 'IT' },
];

const en = {
  header: {
    badge: 'HOC · HOUSE OF CARDS',
    title: 'Bear Hunt Troop Planner',
    subtitle: 'Deal the perfect hand of marches · Kingshot companion',
    quote: '"Play your deck right, the Bear won\u2019t stand a chance."',
  },
  rally: {
    section: 'Rally Settings',
    limitLabel: 'Troop limit per formation',
    limitHint: 'Max {n} marches',
    floorLabel: 'Infantry per formation',
    floorHint: 'Fixed spades placed in every march',
  },
  troops: {
    section: 'Your troops by tier',
    total: 'Total: {n}',
    infantry: 'Infantry',
    cavalry: 'Cavalry',
    archers: 'Archers',
    hint: 'Each formation gets equal Cavalry & Archers (paired 1:1); Infantry fills remaining capacity.',
  },
  mode: {
    section: 'Dealing mode',
    even: 'Even Hand',
    evenSub: 'split tiers evenly',
    royal: 'Royal Flush',
    royalSub: 'highest tier \u2192 formation 1',
  },
  deal: {
    button: 'Deal the Hand',
    bannerWith:
      'Dealing {n} march{plural} (max {max}). Each formation holds {inf} Infantry + paired {cav} Cavalry + {arch} Archers. Mode:',
    bannerEmpty: 'No Cavalry/Archer pairs to deploy. Troops below stay at home or raise rally.',
    noTroops: 'No troops entered yet — add Cavalry, Archers, or Infantry above and deal the hand.',
  },
  formation: {
    title: 'Formation {n}',
    troopsOnly: 'troops only',
    total: 'Total',
  },
  leftover: {
    title: 'The Benched Hand',
    chip: '{n} troops',
    intro: 'Didn\u2019t make it into a march — they\u2019re still ready to play. Pick their next move:',
    optionAHead: 'Hold the House',
    optionADesc:
      'Keep them at HQ playing cards — a cozy defense ring that scares off trap pokers mid-event.',
    optionATag: 'Best for · Full shield / defense',
    optionBHead: 'Deal Your Own Rally',
    optionBDesc:
      'Use them to raise your own rally — HOC joiners fill the empty seats with archers, you take the pot.',
    optionBTag: 'Best for · Final 5-7 minute all-in',
    bench: 'On the bench',
  },
  footer: {
    craftedBy: 'Crafted by',
    attribution: 'For the House of Cards alliance · fan-made, not affiliated with Kingshot',
  },
  clock: {
    title: 'Bear Hunt Clock',
    yourTime: 'Your time',
    utc: 'UTC',
    local: 'local',
    nextIn: 'Next in',
    remind: 'Remind me 5 min before',
    remindOn: 'Reminder on · tap to disable',
    notifTitle: 'Bear Hunt starting soon!',
    notifBody: '{bt} begins in 5 minutes. Deal your hand!',
    notifDenied: 'Browser notifications blocked. Enable them in site settings to get alerts.',
    anchorLabel: 'Next BT day',
    cooldown: '48h cooldown between events',
    restDay: 'Rest day · no BT today',
  },
  presets: {
    section: 'Saved hands',
    saved: 'saved',
    placeholder: 'Name this hand (e.g. "Weekly rally")',
    save: 'Save',
    load: 'Load',
    delete: 'Delete',
    empty: 'No saved hands yet. Save your current setup to replay it anytime.',
  },
};

const ko = {
  header: {
    badge: 'HOC · 하우스 오브 카드',
    title: '베어 헌트 병력 플래너',
    subtitle: '완벽한 진군의 패를 만드세요 · Kingshot 도우미',
    quote: '"덱만 잘 돌리면, 곰은 상대도 안 됩니다."',
  },
  rally: {
    section: '랠리 설정',
    limitLabel: '편성당 병력 한도',
    limitHint: '최대 {n}개 진군',
    floorLabel: '편성당 보병 수',
    floorHint: '모든 진군에 고정 배치되는 스페이드',
  },
  troops: {
    section: '병종·티어별 병력',
    total: '합계: {n}',
    infantry: '보병',
    cavalry: '기병',
    archers: '궁병',
    hint: '각 편성에 기병과 궁병을 1:1로 동일하게 배치하고, 남은 자리는 보병으로 채웁니다.',
  },
  mode: {
    section: '분배 모드',
    even: '이븐 핸드',
    evenSub: '티어를 균등 분배',
    royal: '로열 플러시',
    royalSub: '최상위 티어 \u2192 1편성',
  },
  deal: {
    button: '패 돌리기',
    bannerWith:
      '{n}개 진군 편성 (최대 {max}). 각 편성에 보병 {inf} + 짝지은 {cav} 기병 + {arch} 궁병. 모드:',
    bannerEmpty: '편성할 기병/궁병 쌍이 없습니다. 아래 병력은 집에 두거나 랠리로 사용하세요.',
    noTroops: '아직 입력된 병력이 없습니다 — 위에 기병·궁병·보병을 입력하고 패를 돌리세요.',
  },
  formation: {
    title: '편성 {n}',
    troopsOnly: '병력만',
    total: '합계',
  },
  leftover: {
    title: '벤치의 패',
    chip: '병력 {n}',
    intro: '진군에 들어가지 못했지만 아직 쓸 데가 있습니다. 다음 수를 고르세요:',
    optionAHead: '본진 사수',
    optionADesc:
      'HQ에서 카드나 치며 대기 — 이벤트 중 함정 노리는 찌르기를 쫓아낼 든든한 수비 라인.',
    optionATag: '추천 · 풀 실드 / 방어',
    optionBHead: '내 랠리 소집',
    optionBDesc:
      '자기 랠리를 열어서 사용 — HOC 합류자들이 빈 자리를 궁병으로 채워주면 보상은 당신 몫.',
    optionBTag: '추천 · 마지막 5~7분 올인',
    bench: '벤치 대기',
  },
  footer: {
    craftedBy: '제작',
    attribution: 'House of Cards 연맹을 위한 팬메이드 · Kingshot과 무관합니다',
  },
  clock: {
    title: '베어 헌트 시계',
    yourTime: '내 시간',
    utc: 'UTC',
    local: '현지',
    nextIn: '남은 시간',
    remind: '5분 전 알림 받기',
    remindOn: '알림 설정됨 · 끄려면 탭',
    notifTitle: '베어 헌트가 곧 시작됩니다!',
    notifBody: '{bt}이(가) 5분 후 시작됩니다. 패를 돌리세요!',
    notifDenied: '브라우저 알림이 차단되었습니다. 사이트 설정에서 허용해 주세요.',
    anchorLabel: '다음 BT 날짜',
    cooldown: '이벤트 간 48시간 쿨다운',
    restDay: '휴식일 · 오늘은 BT 없음',
  },
  presets: {
    section: '저장된 패',
    saved: '저장됨',
    placeholder: '이 패의 이름 (예: "주간 랠리")',
    save: '저장',
    load: '불러오기',
    delete: '삭제',
    empty: '아직 저장된 패가 없습니다. 현재 설정을 저장해 두면 언제든 다시 사용할 수 있어요.',
  },
};

const id = {
  header: {
    badge: 'HOC · HOUSE OF CARDS',
    title: 'Perencana Pasukan Bear Hunt',
    subtitle: 'Bagikan tangan march yang sempurna · pendamping Kingshot',
    quote: '"Mainkan kartumu dengan benar, Beruang pun tak berdaya."',
  },
  rally: {
    section: 'Pengaturan Rally',
    limitLabel: 'Batas pasukan per formasi',
    limitHint: 'Maks {n} march',
    floorLabel: 'Infanteri per formasi',
    floorHint: 'Jumlah spade tetap di tiap march',
  },
  troops: {
    section: 'Pasukanmu per tier',
    total: 'Total: {n}',
    infantry: 'Infanteri',
    cavalry: 'Kavaleri',
    archers: 'Pemanah',
    hint: 'Tiap formasi mendapat Kavaleri & Pemanah sama rata (1:1); Infanteri mengisi sisa kapasitas.',
  },
  mode: {
    section: 'Mode pembagian',
    even: 'Even Hand',
    evenSub: 'bagi tier merata',
    royal: 'Royal Flush',
    royalSub: 'tier tertinggi \u2192 formasi 1',
  },
  deal: {
    button: 'Bagikan Kartunya',
    bannerWith:
      'Membagikan {n} march (maks {max}). Tiap formasi berisi {inf} Infanteri + berpasangan {cav} Kavaleri + {arch} Pemanah. Mode:',
    bannerEmpty: 'Tidak ada pasangan Kavaleri/Pemanah untuk dikirim. Pasukan di bawah tetap di rumah atau untuk rally.',
    noTroops: 'Belum ada pasukan — isi Kavaleri, Pemanah, atau Infanteri di atas lalu bagikan kartunya.',
  },
  formation: {
    title: 'Formasi {n}',
    troopsOnly: 'tanpa hero',
    total: 'Total',
  },
  leftover: {
    title: 'Kartu Cadangan',
    chip: '{n} pasukan',
    intro: 'Belum masuk ke march — tapi masih siap main. Pilih langkah selanjutnya:',
    optionAHead: 'Jaga Markas',
    optionADesc:
      'Simpan mereka di HQ sambil main kartu — pertahanan nyaman yang bikin pengganggu kabur di tengah event.',
    optionATag: 'Cocok · Shield penuh / bertahan',
    optionBHead: 'Buka Rally Sendiri',
    optionBDesc:
      'Pakai mereka untuk membuka rally sendiri — anggota HOC mengisi kursi kosong dengan pemanah, hadiah untukmu.',
    optionBTag: 'Cocok · 5-7 menit terakhir all-in',
    bench: 'Di bangku cadangan',
  },
  footer: {
    craftedBy: 'Dibuat oleh',
    attribution: 'Untuk alliance House of Cards · buatan fan, bukan afiliasi Kingshot',
  },
  clock: {
    title: 'Jam Bear Hunt',
    yourTime: 'Waktumu',
    utc: 'UTC',
    local: 'lokal',
    nextIn: 'Berikutnya dalam',
    remind: 'Ingatkan 5 menit sebelumnya',
    remindOn: 'Pengingat aktif · ketuk untuk matikan',
    notifTitle: 'Bear Hunt akan dimulai!',
    notifBody: '{bt} dimulai 5 menit lagi. Bagikan kartumu!',
    notifDenied: 'Notifikasi browser diblokir. Aktifkan di pengaturan situs.',
    anchorLabel: 'Hari BT berikutnya',
    cooldown: 'Cooldown 48 jam antar event',
    restDay: 'Hari istirahat · tidak ada BT hari ini',
  },
  presets: {
    section: 'Simpanan Tangan',
    saved: 'tersimpan',
    placeholder: 'Nama tangan (misal "Rally mingguan")',
    save: 'Simpan',
    load: 'Muat',
    delete: 'Hapus',
    empty: 'Belum ada tangan tersimpan. Simpan pengaturanmu untuk dipakai lagi kapan saja.',
  },
};

const ptBR = {
  header: {
    badge: 'HOC · HOUSE OF CARDS',
    title: 'Planejador de Tropas Bear Hunt',
    subtitle: 'Distribua a mão perfeita de marchas · companheiro Kingshot',
    quote: '"Jogue suas cartas certo e o Urso nem tem chance."',
  },
  rally: {
    section: 'Configurações da Rally',
    limitLabel: 'Limite de tropas por formação',
    limitHint: 'Máx. {n} marchas',
    floorLabel: 'Infantaria por formação',
    floorHint: 'Espadas fixas em cada marcha',
  },
  troops: {
    section: 'Suas tropas por tier',
    total: 'Total: {n}',
    infantry: 'Infantaria',
    cavalry: 'Cavalaria',
    archers: 'Arqueiros',
    hint: 'Cada formação recebe Cavalaria & Arqueiros iguais (1:1); a Infantaria preenche o restante.',
  },
  mode: {
    section: 'Modo de distribuição',
    even: 'Mão Equilibrada',
    evenSub: 'divide tiers igualmente',
    royal: 'Royal Flush',
    royalSub: 'tier mais alto \u2192 formação 1',
  },
  deal: {
    button: 'Distribuir a Mão',
    bannerWith:
      'Distribuindo {n} marcha{plural} (máx. {max}). Cada formação leva {inf} de Infantaria + pareado {cav} Cavalaria + {arch} Arqueiros. Modo:',
    bannerEmpty: 'Sem pares de Cavalaria/Arqueiros para enviar. Tropas abaixo ficam em casa ou levantam rally.',
    noTroops: 'Nenhuma tropa inserida — adicione Cavalaria, Arqueiros ou Infantaria acima e distribua a mão.',
  },
  formation: {
    title: 'Formação {n}',
    troopsOnly: 'só tropas',
    total: 'Total',
  },
  leftover: {
    title: 'A Mão de Reserva',
    chip: '{n} tropas',
    intro: 'Não entraram na marcha — mas ainda estão prontos. Escolha o próximo movimento:',
    optionAHead: 'Guardar a Casa',
    optionADesc:
      'Deixe-os no HQ jogando cartas — um anel de defesa aconchegante que afasta espiões no meio do evento.',
    optionATag: 'Ideal · Shield total / defesa',
    optionBHead: 'Abrir Sua Rally',
    optionBDesc:
      'Use-os para abrir sua própria rally — HOC entra com arqueiros nos lugares vazios e o prêmio é seu.',
    optionBTag: 'Ideal · últimos 5-7 min de all-in',
    bench: 'No banco',
  },
  footer: {
    craftedBy: 'Feito por',
    attribution: 'Para a aliança House of Cards · feito por fã, sem relação oficial com Kingshot',
  },
  clock: {
    title: 'Relógio do Bear Hunt',
    yourTime: 'Seu horário',
    utc: 'UTC',
    local: 'local',
    nextIn: 'Próximo em',
    remind: 'Lembrar 5 min antes',
    remindOn: 'Lembrete ativo · toque para desativar',
    notifTitle: 'Bear Hunt começando!',
    notifBody: '{bt} começa em 5 minutos. Distribua sua mão!',
    notifDenied: 'Notificações bloqueadas. Ative nas configurações do site.',
    anchorLabel: 'Próximo dia de BT',
    cooldown: 'Cooldown de 48h entre eventos',
    restDay: 'Dia de descanso · sem BT hoje',
  },
  presets: {
    section: 'Mãos salvas',
    saved: 'salvas',
    placeholder: 'Nome da mão (ex: "Rally semanal")',
    save: 'Salvar',
    load: 'Carregar',
    delete: 'Excluir',
    empty: 'Nenhuma mão salva. Salve sua configuração para reusar quando quiser.',
  },
};

const th = {
  header: {
    badge: 'HOC · HOUSE OF CARDS',
    title: 'ตัววางแผนกองทัพ Bear Hunt',
    subtitle: 'แจกมือ march ที่สมบูรณ์แบบ · ผู้ช่วย Kingshot',
    quote: '"เล่นไพ่ให้ถูก หมีไม่มีทางสู้ได้เลย"',
  },
  rally: {
    section: 'ตั้งค่าการ Rally',
    limitLabel: 'จำกัดจำนวนทหารต่อ formation',
    limitHint: 'สูงสุด {n} marches',
    floorLabel: 'จำนวน Infantry ต่อ formation',
    floorHint: 'จำนวนโพดำที่กำหนดในทุก march',
  },
  troops: {
    section: 'ทหารของคุณแยกตามเทียร์',
    total: 'รวม: {n}',
    infantry: 'ทหารราบ',
    cavalry: 'ทหารม้า',
    archers: 'ธนู',
    hint: 'ทุก formation มีทหารม้า & ธนูเท่ากัน (จับคู่ 1:1); ส่วนที่เหลือเติมด้วยทหารราบ',
  },
  mode: {
    section: 'โหมดการแจก',
    even: 'Even Hand',
    evenSub: 'แบ่งเทียร์เท่ากัน',
    royal: 'Royal Flush',
    royalSub: 'เทียร์สูงสุด \u2192 formation 1',
  },
  deal: {
    button: 'แจกไพ่',
    bannerWith:
      'กำลังแจก {n} march (สูงสุด {max}) ทุก formation มีทหารราบ {inf} + จับคู่ {cav} ทหารม้า + {arch} ธนู โหมด:',
    bannerEmpty: 'ไม่มีคู่ทหารม้า/ธนูให้ส่ง ทหารด้านล่างให้อยู่บ้านหรือเปิด rally',
    noTroops: 'ยังไม่ได้ใส่ทหาร — ใส่ทหารม้า ธนู หรือทหารราบด้านบนแล้วแจกไพ่',
  },
  formation: {
    title: 'Formation {n}',
    troopsOnly: 'ไม่มีฮีโร่',
    total: 'รวม',
  },
  leftover: {
    title: 'ไพ่สำรอง',
    chip: 'ทหาร {n}',
    intro: 'ไม่ได้เข้า march — แต่ยังพร้อมเล่น เลือกการใช้งานถัดไป:',
    optionAHead: 'เฝ้าบ้าน',
    optionADesc:
      'เก็บไว้ที่ HQ เล่นไพ่กันไป — แนวป้องกันสบายๆ ไว้ไล่คนที่มาจิ้มระหว่างอีเวนต์',
    optionATag: 'เหมาะกับ · โล่เต็ม / ป้องกัน',
    optionBHead: 'เปิด Rally ของตัวเอง',
    optionBDesc:
      'ใช้พวกเขาเปิด rally ของคุณเอง — สมาชิก HOC จะเติมที่ว่างด้วยธนู แล้วรางวัลเป็นของคุณ',
    optionBTag: 'เหมาะกับ · 5-7 นาทีสุดท้ายทุ่มสุดตัว',
    bench: 'นั่งสำรอง',
  },
  footer: {
    craftedBy: 'สร้างโดย',
    attribution: 'สำหรับพันธมิตร House of Cards · ทำโดยแฟน ไม่ได้สังกัด Kingshot',
  },
  clock: {
    title: 'นาฬิกา Bear Hunt',
    yourTime: 'เวลาของคุณ',
    utc: 'UTC',
    local: 'เวลาท้องถิ่น',
    nextIn: 'ครั้งถัดไปในอีก',
    remind: 'เตือนก่อน 5 นาที',
    remindOn: 'เปิดการแจ้งเตือนแล้ว · แตะเพื่อปิด',
    notifTitle: 'Bear Hunt กำลังจะเริ่ม!',
    notifBody: '{bt} จะเริ่มในอีก 5 นาที แจกไพ่ได้เลย!',
    notifDenied: 'ปิดการแจ้งเตือนของเบราว์เซอร์ไว้ โปรดเปิดในการตั้งค่าเว็บไซต์',
    anchorLabel: 'วัน BT ถัดไป',
    cooldown: 'คูลดาวน์ 48 ชั่วโมงระหว่างอีเวนต์',
    restDay: 'วันพัก · ไม่มี BT วันนี้',
  },
  presets: {
    section: 'มือที่บันทึก',
    saved: 'ที่บันทึกไว้',
    placeholder: 'ตั้งชื่อมือนี้ (เช่น "Rally รายสัปดาห์")',
    save: 'บันทึก',
    load: 'โหลด',
    delete: 'ลบ',
    empty: 'ยังไม่มีมือที่บันทึก บันทึกการตั้งค่าเพื่อใช้งานซ้ำได้ตลอด',
  },
};

const fil = {
  header: {
    badge: 'HOC · HOUSE OF CARDS',
    title: 'Bear Hunt Troop Planner',
    subtitle: 'I-deal ang perpektong kamay ng mga march · katuwang mo sa Kingshot',
    quote: '"Kung tama ang laro mo sa baraha, wala nang laban ang Oso."',
  },
  rally: {
    section: 'Mga Setting ng Rally',
    limitLabel: 'Limitasyon ng tropa kada formation',
    limitHint: 'Hanggang {n} marches',
    floorLabel: 'Infantry kada formation',
    floorHint: 'Nakatakdang spades sa bawat march',
  },
  troops: {
    section: 'Mga tropa mo kada tier',
    total: 'Kabuuan: {n}',
    infantry: 'Infantry',
    cavalry: 'Kabayuhan',
    archers: 'Mamamana',
    hint: 'Bawat formation ay may pantay na Kabayuhan at Mamamana (1:1); Infantry ang pupuno ng natitirang espasyo.',
  },
  mode: {
    section: 'Paraan ng paghati',
    even: 'Even Hand',
    evenSub: 'pantay-pantay ang mga tier',
    royal: 'Royal Flush',
    royalSub: 'pinakamataas na tier \u2192 formation 1',
  },
  deal: {
    button: 'I-deal ang Kamay',
    bannerWith:
      'Nagdi-deal ng {n} na march (hanggang {max}). Bawat formation ay may {inf} Infantry + pares na {cav} Kabayuhan + {arch} Mamamana. Mode:',
    bannerEmpty: 'Walang pares ng Kabayuhan/Mamamana para ipadala. Manatili sa bahay ang mga tropa sa ibaba o maglagay ng rally.',
    noTroops: 'Wala pang tropang nailagay — maglagay ng Kabayuhan, Mamamana, o Infantry sa itaas at i-deal ang kamay.',
  },
  formation: {
    title: 'Formation {n}',
    troopsOnly: 'tropa lang',
    total: 'Kabuuan',
  },
  leftover: {
    title: 'Ang Nakareserba',
    chip: '{n} na tropa',
    intro: 'Hindi nakapasok sa march — pero handa pa rin maglaro. Pumili ng susunod na hakbang:',
    optionAHead: 'Bantayan ang Bahay',
    optionADesc:
      'Ipanatili sila sa HQ habang naglalaro ng baraha — komportableng depensa na tumatakot sa mga sumasalakay sa gitna ng event.',
    optionATag: 'Pinakamainam · Full shield / depensa',
    optionBHead: 'Mag-rally Ka Mismo',
    optionBDesc:
      'Gamitin sila para magbukas ng sarili mong rally — mga HOC joiner ang pupuno ng mga puwesto gamit ang mamamana, iyo ang gantimpala.',
    optionBTag: 'Pinakamainam · Huling 5-7 minutong all-in',
    bench: 'Nasa bench',
  },
  footer: {
    craftedBy: 'Ginawa ni',
    attribution: 'Para sa alyansang House of Cards · gawa ng fan, walang kaugnayan sa Kingshot',
  },
  clock: {
    title: 'Orasan ng Bear Hunt',
    yourTime: 'Oras mo',
    utc: 'UTC',
    local: 'lokal',
    nextIn: 'Susunod sa',
    remind: 'Ipaalala 5 min bago',
    remindOn: 'Nakatakda ang paalala · pindutin para patayin',
    notifTitle: 'Magsisimula na ang Bear Hunt!',
    notifBody: 'Magsisimula ang {bt} sa 5 minuto. I-deal ang kamay mo!',
    notifDenied: 'Naka-block ang notifications ng browser. I-enable sa site settings.',
    anchorLabel: 'Susunod na araw ng BT',
    cooldown: '48h cooldown bawat event',
    restDay: 'Rest day · walang BT ngayon',
  },
  presets: {
    section: 'Mga naka-save na kamay',
    saved: 'na-save',
    placeholder: 'Pangalan ng kamay (hal. "Lingguhang rally")',
    save: 'I-save',
    load: 'I-load',
    delete: 'Burahin',
    empty: 'Wala pang naka-save. I-save ang kasalukuyang setup para magamit ulit.',
  },
};

const zh = {
  header: {
    badge: 'HOC · 纸牌屋联盟',
    title: '熊猎兵力规划器',
    subtitle: '发出完美的出征之手 · Kingshot 助手',
    quote: '"牌出得准，熊也只能认输。"',
  },
  rally: {
    section: '集结设置',
    limitLabel: '每个编队的兵力上限',
    limitHint: '最多 {n} 次出征',
    floorLabel: '每个编队的步兵数量',
    floorHint: '每次出征固定投入的黑桃数',
  },
  troops: {
    section: '按阶级统计你的部队',
    total: '合计：{n}',
    infantry: '步兵',
    cavalry: '骑兵',
    archers: '弓箭手',
    hint: '每个编队的骑兵与弓箭手数量相等（1:1 配对），步兵填满剩余容量。',
  },
  mode: {
    section: '分配模式',
    even: 'Even Hand',
    evenSub: '阶级均匀分配',
    royal: 'Royal Flush',
    royalSub: '最高阶 \u2192 编队 1',
  },
  deal: {
    button: '发牌出征',
    bannerWith:
      '正在发出 {n} 次出征（最多 {max}）。每队含 {inf} 步兵 + 配对 {cav} 骑兵 + {arch} 弓箭手。模式：',
    bannerEmpty: '没有可用的骑兵/弓箭手配对，下方部队请留守或开启集结。',
    noTroops: '尚未输入部队 — 请在上方填入骑兵、弓箭手或步兵，然后点击发牌出征。',
  },
  formation: {
    title: '编队 {n}',
    troopsOnly: '仅部队',
    total: '合计',
  },
  leftover: {
    title: '替补之手',
    chip: '{n} 名部队',
    intro: '没能登上出征 — 但仍待命出场。请为他们选择下一步：',
    optionAHead: '守护本城',
    optionADesc:
      '让他们留在 HQ 打牌 — 一道温馨的防御圈，在活动中赶走想偷袭的敌人。',
    optionATag: '适合 · 全盾 / 防守',
    optionBHead: '自己开集结',
    optionBDesc:
      '用他们开启你自己的集结 — HOC 的队友会带弓箭手填满空位，奖励归你。',
    optionBTag: '适合 · 最后 5-7 分钟全力一击',
    bench: '替补席',
  },
  footer: {
    craftedBy: '作者',
    attribution: '献给纸牌屋联盟 · 粉丝自制，与 Kingshot 官方无关',
  },
  clock: {
    title: '熊猎时钟',
    yourTime: '你的时间',
    utc: 'UTC',
    local: '本地',
    nextIn: '距离下一次',
    remind: '提前 5 分钟提醒',
    remindOn: '提醒已开启 · 点击关闭',
    notifTitle: '熊猎即将开始！',
    notifBody: '{bt} 将在 5 分钟后开始，开始发牌吧！',
    notifDenied: '浏览器通知已被阻止，请在站点设置中开启。',
    anchorLabel: '下次熊猎日期',
    cooldown: '活动间冷却 48 小时',
    restDay: '休息日 · 今日无熊猎',
  },
  presets: {
    section: '已保存的牌',
    saved: '已保存',
    placeholder: '为此牌命名（如"每周集结"）',
    save: '保存',
    load: '载入',
    delete: '删除',
    empty: '暂无保存的配置。保存当前设置以便随时调用。',
  },
};

const es = {
  header: {
    badge: 'HOC · HOUSE OF CARDS',
    title: 'Planificador de Tropas Bear Hunt',
    subtitle: 'Reparte la mano perfecta de marchas · compañero de Kingshot',
    quote: '"Juega bien tus cartas y el Oso no tiene nada que hacer."',
  },
  rally: {
    section: 'Ajustes de Rally',
    limitLabel: 'Límite de tropas por formación',
    limitHint: 'Máx. {n} marchas',
    floorLabel: 'Infantería por formación',
    floorHint: 'Picas fijas en cada marcha',
  },
  troops: {
    section: 'Tus tropas por nivel',
    total: 'Total: {n}',
    infantry: 'Infantería',
    cavalry: 'Caballería',
    archers: 'Arqueros',
    hint: 'Cada formación lleva Caballería y Arqueros iguales (1:1); la Infantería rellena el resto.',
  },
  mode: {
    section: 'Modo de reparto',
    even: 'Mano Pareja',
    evenSub: 'reparte niveles por igual',
    royal: 'Royal Flush',
    royalSub: 'nivel más alto \u2192 formación 1',
  },
  deal: {
    button: 'Repartir la Mano',
    bannerWith:
      'Repartiendo {n} marcha{plural} (máx. {max}). Cada formación lleva {inf} de Infantería + emparejado {cav} Caballería + {arch} Arqueros. Modo:',
    bannerEmpty: 'No hay pares de Caballería/Arqueros para enviar. Las tropas de abajo se quedan en casa o levantan rally.',
    noTroops: 'Aún no hay tropas — añade Caballería, Arqueros o Infantería arriba y reparte la mano.',
  },
  formation: {
    title: 'Formación {n}',
    troopsOnly: 'solo tropas',
    total: 'Total',
  },
  leftover: {
    title: 'La Mano de Reserva',
    chip: '{n} tropas',
    intro: 'No entraron a la marcha — pero siguen listas para jugar. Elige su próximo movimiento:',
    optionAHead: 'Cuidar la Casa',
    optionADesc:
      'Déjalos en el HQ jugando a las cartas — un anillo de defensa cómodo que ahuyenta a los que buscan la trampa a mitad de evento.',
    optionATag: 'Ideal · Shield total / defensa',
    optionBHead: 'Abre Tu Propia Rally',
    optionBDesc:
      'Úsalos para abrir tu propia rally — los HOC se suman con arqueros para los asientos vacíos, el premio es tuyo.',
    optionBTag: 'Ideal · Últimos 5-7 min de all-in',
    bench: 'En el banco',
  },
  footer: {
    craftedBy: 'Creado por',
    attribution: 'Para la alianza House of Cards · hecho por un fan, sin afiliación con Kingshot',
  },
  clock: {
    title: 'Reloj Bear Hunt',
    yourTime: 'Tu hora',
    utc: 'UTC',
    local: 'local',
    nextIn: 'Próximo en',
    remind: 'Avísame 5 min antes',
    remindOn: 'Recordatorio activo · toca para desactivar',
    notifTitle: '¡Bear Hunt a punto de empezar!',
    notifBody: '{bt} empieza en 5 minutos. ¡Reparte tu mano!',
    notifDenied: 'Las notificaciones del navegador están bloqueadas. Actívalas en los ajustes del sitio.',
    anchorLabel: 'Próximo día de BT',
    cooldown: 'Enfriamiento de 48h entre eventos',
    restDay: 'Día de descanso · sin BT hoy',
  },
  presets: {
    section: 'Manos guardadas',
    saved: 'guardadas',
    placeholder: 'Nombre de la mano (ej. "Rally semanal")',
    save: 'Guardar',
    load: 'Cargar',
    delete: 'Eliminar',
    empty: 'Aún no hay manos guardadas. Guarda tu configuración para reutilizarla.',
  },
};

const ro = {
  header: {
    badge: 'HOC · HOUSE OF CARDS',
    title: 'Planificator de Trupe Bear Hunt',
    subtitle: 'Împarte mâna perfectă de marșuri · companion Kingshot',
    quote: '"Dacă joci cărțile corect, Ursul nu are nicio șansă."',
  },
  rally: {
    section: 'Setări Rally',
    limitLabel: 'Limită de trupe per formație',
    limitHint: 'Maxim {n} marșuri',
    floorLabel: 'Infanterie per formație',
    floorHint: 'Picoane fixe în fiecare marș',
  },
  troops: {
    section: 'Trupele tale pe nivel',
    total: 'Total: {n}',
    infantry: 'Infanterie',
    cavalry: 'Cavalerie',
    archers: 'Arcași',
    hint: 'Fiecare formație are Cavalerie și Arcași egali (1:1); Infanteria umple restul capacității.',
  },
  mode: {
    section: 'Mod de împărțire',
    even: 'Mână Echilibrată',
    evenSub: 'niveluri împărțite egal',
    royal: 'Royal Flush',
    royalSub: 'cel mai înalt nivel \u2192 formația 1',
  },
  deal: {
    button: 'Împarte Mâna',
    bannerWith:
      'Împart {n} marș{plural} (max {max}). Fiecare formație are {inf} Infanterie + {cav} Cavalerie + {arch} Arcași în pereche. Mod:',
    bannerEmpty: 'Nu există perechi Cavalerie/Arcași de trimis. Trupele de mai jos rămân acasă sau pornesc rally.',
    noTroops: 'Nicio trupă introdusă încă — adaugă Cavalerie, Arcași sau Infanterie mai sus și împarte mâna.',
  },
  formation: {
    title: 'Formația {n}',
    troopsOnly: 'doar trupe',
    total: 'Total',
  },
  leftover: {
    title: 'Mâna de Rezervă',
    chip: '{n} trupe',
    intro: 'Nu au prins marșul — dar sunt gata de joc. Alege următoarea mișcare:',
    optionAHead: 'Păzește Casa',
    optionADesc:
      'Ține-i la HQ jucând cărți — un inel de apărare primitor care sperie intrușii la mijlocul evenimentului.',
    optionATag: 'Ideal · Shield complet / defensivă',
    optionBHead: 'Deschide Propriul Rally',
    optionBDesc:
      'Folosește-i să deschizi propriul rally — colegii HOC umplu locurile libere cu arcași, premiul e al tău.',
    optionBTag: 'Ideal · Ultimele 5-7 minute all-in',
    bench: 'Pe bancă',
  },
  footer: {
    craftedBy: 'Creat de',
    attribution: 'Pentru alianța House of Cards · făcut de fani, fără afiliere oficială cu Kingshot',
  },
  clock: {
    title: 'Ceasul Bear Hunt',
    yourTime: 'Ora ta',
    utc: 'UTC',
    local: 'local',
    nextIn: 'Următorul în',
    remind: 'Amintește-mi cu 5 min înainte',
    remindOn: 'Memento activ · apasă pentru dezactivare',
    notifTitle: 'Bear Hunt începe în curând!',
    notifBody: '{bt} începe în 5 minute. Împarte mâna!',
    notifDenied: 'Notificările browserului sunt blocate. Activează-le din setările site-ului.',
    anchorLabel: 'Următoarea zi BT',
    cooldown: 'Răcorire de 48h între evenimente',
    restDay: 'Zi de pauză · fără BT azi',
  },
  presets: {
    section: 'Mâini salvate',
    saved: 'salvate',
    placeholder: 'Nume mână (ex. "Rally săptămânal")',
    save: 'Salvează',
    load: 'Încarcă',
    delete: 'Șterge',
    empty: 'Nicio mână salvată încă. Salvează setarea curentă ca s-o reutilizezi oricând.',
  },
};

const it = {
  header: {
    badge: 'HOC · HOUSE OF CARDS',
    title: 'Pianificatore Truppe Bear Hunt',
    subtitle: 'Distribuisci la mano perfetta di marce · compagno Kingshot',
    quote: '"Gioca bene le tue carte e l\u2019Orso non ha scampo."',
  },
  rally: {
    section: 'Impostazioni Rally',
    limitLabel: 'Limite truppe per formazione',
    limitHint: 'Max {n} marce',
    floorLabel: 'Fanteria per formazione',
    floorHint: 'Picche fisse in ogni marcia',
  },
  troops: {
    section: 'Le tue truppe per livello',
    total: 'Totale: {n}',
    infantry: 'Fanteria',
    cavalry: 'Cavalleria',
    archers: 'Arcieri',
    hint: 'Ogni formazione ha pari Cavalleria e Arcieri (1:1); la Fanteria riempie lo spazio restante.',
  },
  mode: {
    section: 'Modalità di distribuzione',
    even: 'Mano Pari',
    evenSub: 'livelli distribuiti equamente',
    royal: 'Royal Flush',
    royalSub: 'livello più alto \u2192 formazione 1',
  },
  deal: {
    button: 'Distribuisci la Mano',
    bannerWith:
      'Distribuzione di {n} marc{plural} (max {max}). Ogni formazione ha {inf} Fanteria + {cav} Cavalleria + {arch} Arcieri in coppia. Modalità:',
    bannerEmpty: 'Nessuna coppia Cavalleria/Arcieri da inviare. Le truppe sotto restano a casa o aprono rally.',
    noTroops: 'Nessuna truppa inserita — aggiungi Cavalleria, Arcieri o Fanteria sopra e distribuisci la mano.',
  },
  formation: {
    title: 'Formazione {n}',
    troopsOnly: 'solo truppe',
    total: 'Totale',
  },
  leftover: {
    title: 'La Mano di Riserva',
    chip: '{n} truppe',
    intro: 'Non sono entrate nella marcia — ma sono pronte a giocare. Scegli la prossima mossa:',
    optionAHead: 'Difendi la Casa',
    optionADesc:
      'Tienili all\u2019HQ a giocare a carte — un cerchio di difesa accogliente che scaccia chi tenta la trappola a metà evento.',
    optionATag: 'Ideale · Shield totale / difesa',
    optionBHead: 'Apri la Tua Rally',
    optionBDesc:
      'Usali per aprire la tua rally — i compagni HOC riempiono i posti vuoti con arcieri, il premio è tuo.',
    optionBTag: 'Ideale · Ultimi 5-7 minuti all-in',
    bench: 'In panchina',
  },
  footer: {
    craftedBy: 'Creato da',
    attribution: 'Per l\u2019alleanza House of Cards · fatto da fan, senza affiliazione con Kingshot',
  },
  clock: {
    title: 'Orologio Bear Hunt',
    yourTime: 'La tua ora',
    utc: 'UTC',
    local: 'locale',
    nextIn: 'Prossimo tra',
    remind: 'Avvisami 5 min prima',
    remindOn: 'Promemoria attivo · tocca per disattivare',
    notifTitle: 'Bear Hunt sta per iniziare!',
    notifBody: '{bt} inizia tra 5 minuti. Distribuisci la mano!',
    notifDenied: 'Notifiche del browser bloccate. Attivale dalle impostazioni del sito.',
    anchorLabel: 'Prossimo giorno BT',
    cooldown: 'Cooldown di 48h tra eventi',
    restDay: 'Giorno di riposo · nessun BT oggi',
  },
  presets: {
    section: 'Mani salvate',
    saved: 'salvate',
    placeholder: 'Nome della mano (es. "Rally settimanale")',
    save: 'Salva',
    load: 'Carica',
    delete: 'Elimina',
    empty: 'Nessuna mano salvata. Salva la configurazione attuale per riutilizzarla.',
  },
};

export const TRANSLATIONS = { en, ko, id, 'pt-BR': ptBR, th, fil, zh, es, ro, it };

export const DEFAULT_LANG = 'en';

export function format(str, vars = {}) {
  if (!str) return '';
  return str.replace(/\{(\w+)\}/g, (_, key) => (vars[key] !== undefined ? String(vars[key]) : `{${key}}`));
}
